import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Certificate from './Certificate';

const GenerateCertificate = () => {
  const { backgroundImage, logoImage, studentPhoto, topMarginFrame, students } =
    useLocation().state;

  // Create refs ONCE (same order as students)
  const certificateRefs = useRef([]);

  // Ensure refs array length matches students
  certificateRefs.current = students.map(
    (_, i) => certificateRefs.current[i] || React.createRef()
  );

  return (
    <>
      {students.map((student, index) => (
        <Certificate
          key={index}
          ref={certificateRefs.current[index]}
          student={student}
          backgroundImage={backgroundImage}
          logoImage={logoImage}
          studentPhoto={student.photo || studentPhoto}
          topMarginFrame={topMarginFrame}
        />
      ))}
    </>
  );
};

export default GenerateCertificate;
